import React from 'react';
const bonos = [{
  icon: '📋',
  number: 'Bono 1',
  title: 'Bono 1 — Kit de Arranque Rápido',
  desc: 'Empezá a usar Rugby 360 en 10 minutos. Guía de activación, estructura del sistema y tu primera sesión lista para hoy.'
}, {
  icon: '🗓️',
  number: 'Bono 2',
  title: 'Bono 2 — Planilla Maestra Semanal',
  desc: 'Organizá toda tu semana de rugby en una sola hoja. Tracker, objetivos y cierre de sesión integrados.'
}, {
  icon: '🎯',
  number: 'Bono 3',
  title: 'Bono 3 — Banco Express de Correcciones',
  desc: 'Qué corregir, cómo decirlo y cuándo intervenir sin cortar el ritmo. Frases listas para usar en el campo.'
}, {
  icon: '⚡',
  number: 'Bono 4',
  title: 'Bono 4 — Checklist Pre Entreno en 3 Minutos',
  desc: 'El sistema para ordenar la cabeza antes de salir al campo aunque llegues cansado, tarde o sin haber preparado nada.'
}, {
  icon: '🔧',
  number: 'Bono 5',
  title: 'Bono 5 — Guía de Adaptación Rápida',
  desc: 'Cómo entrenar bien aunque falte espacio, jugadores o material. La forma siempre puede cambiar. El objetivo no.'
}, {
  icon: '📊',
  number: 'Bono 6',
  title: 'Bono 6 — Hoja de Cierre Post Entreno',
  desc: 'Terminá cada entrenamiento sabiendo qué funcionó, qué corregir y cómo mejorar la próxima sesión.'
}];
export function BonosSection() {
  return <section className="bg-[#F5F5F5] py-20 px-4" data-id="element-19">
      <div className="max-w-6xl mx-auto" data-id="element-20">
        <div className="text-center mb-14" data-id="element-21">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-22">
            + 6 Regalos Estratégicos
          </h2>
          <p className="text-lg md:text-xl text-gray-500 mb-6" data-id="element-23">
            Incluidos sin costo extra · Valor real del pack
          </p>
          <div className="inline-block bg-[#1B4D2E] text-white px-6 py-2.5 rounded-full font-bold text-sm md:text-base uppercase tracking-wide shadow-md" data-id="element-24">
            🎁 GRATIS POR EL DÍA DE HOY
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-25">
          {bonos.map((bono, i) => <div key={i} className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 hover:shadow-lg transition-shadow flex flex-col items-center text-center" data-id="element-26">
              {/* Book cover mockup */}
              <div className="relative mb-6" data-id="element-27">
                <div className="relative w-44 h-56 rounded-r-lg rounded-l-sm bg-[#1B4D2E] shadow-xl overflow-hidden flex flex-col p-5" data-id="element-28">
                  {/* spine */}
                  <div className="absolute left-0 top-0 h-full w-4 bg-black/20" data-id="element-29" />
                  <div className="pl-4 flex flex-col h-full" data-id="element-30">
                    <div className="text-4xl mb-auto" data-id="element-31">{bono.icon}</div>
                    <div className="text-white text-xl font-bold mb-3" data-id="element-32">
                      {bono.number}
                    </div>
                    <div className="border-t border-white/30 w-2/3 mb-4" data-id="element-33" />
                    <div className="text-white/70 text-xs font-semibold tracking-widest uppercase" data-id="element-34">
                      Rugby 360™
                    </div>
                  </div>
                </div>
              </div>

              {/* GRATIS pill */}
              <div className="inline-block bg-green-100 text-green-700 px-4 py-1 rounded-full font-bold text-sm mb-4" data-id="element-35">
                GRATIS
              </div>

              <h4 className="font-bold text-xl text-gray-900 mb-3 leading-snug" data-id="element-36">
                {bono.icon} {bono.title}
              </h4>
              <p className="text-gray-500 leading-relaxed" data-id="element-37">{bono.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}